import React, { useCallback, useState } from "react";
import {
  AutoCompleteField,
  form,
  Form as AppForm
} from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import PropTypes from "prop-types";
import { Col } from "react-bootstrap";
import api from "APP_ROOT/api";
import FormRow from "MODULES/shared/components/Forms/FormRow";

function Form(props) {
  const [selectedPart, setSelectedPart] = useState();
  const searchParts = useCallback(filter =>
    api.parts
      .search({ search_type: "search", part_number: filter })
      .then(({ data: { results } }) =>
        results.filter(p => p.id !== props.partId)
      )
  );

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <h4>To which existing Part Number would you like to merge data?</h4>
        </FormRow>
        <FormRow>
          <Col md={6} mdOffset={3}>
            <Field
              name="merge_part_id"
              label="Part #"
              placeholder="Type a part's number..."
              component={AutoCompleteField}
              search={searchParts}
              selectedItem={selectedPart}
              formatItem={result => result && result.part_number}
              onItemSelected={i => i && setSelectedPart(i)}
              required
            />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  partId: PropTypes.number.isRequired,
  showPartInput: PropTypes.bool
};

const FORM_NAME = "mergePart";

export default form({
  form: FORM_NAME
})(Form);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/MergePartModal/Form.jsx